function validateSD(state) {
  // fetch input strings, check of undefined/null and set them in state
  let emailString = document.getElementById('email-input').value;
  let descriptionString = document.getElementById('description-input').value;
  emailString = checkIfEmpty(emailString);
  descriptionString = checkIfEmpty(descriptionString);
  state.syndisInputs.emailInput = emailString;
  state.syndisInputs.descriptionInput = descriptionString;

  // Split strings into lists and normalize
  let emailList = makeList(emailString);
  emailList = normalizeList(emailList);

  // validate lists
  if (!validateEmailList(emailList)) {
    state.syndisInputs.emailError = true;
  }

  // Validation of based on protection type chosen
  if (state.syndisInputs.useProtection && state.syndisInputs.usePwd) {
    validationForPassword(state);
  } else if (state.syndisInputs.useProtection && state.syndisInputs.useSSN) {
    validationForSSN(state);
  }

  // Check if an input string is invalid
  if (
    state.syndisInputs.emailError ||
    state.syndisInputs.phoneError ||
    state.syndisInputs.ssnError ||
    state.syndisInputs.pwdError
  ) {
    return false;
  }

  state.syndisData.emailList = emailList;
  state.syndisData.description = descriptionString;
  return true;
}

// undefined/null check
function checkIfEmpty(inputString) {
  if (
    typeof inputString === 'undefined' ||
    inputString == null ||
    inputString.length === 0
  ) {
    return '';
  }
  return inputString;
}

// make item lists from the input strings
function makeList(inputString) {
  return inputString
    .trim()
    .replace(/\s/g, '')
    .split(',');
}

// removes empty strings from list
function removeEmptyStrings(list) {
  return list.filter(Boolean);
}

function removeDuplicates(list) {
  return [...new Set(list)];
}

function normalizeList(list) {
  list = removeEmptyStrings(list);
  return removeDuplicates(list);
}

// validate the input strings
function validateEmailList(emailList) {
  for (let i = 0; i < emailList.length; i++) {
    if (!isEmailValid(emailList[i])) {
      return false;
    }
  }
  return true;
}

// validate an email address
function isEmailValid(email) {
  // regex to validate email
  return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email);
}

// validation for phonelist if password protected
function validationForPassword(state) {
  var passwordString = document.getElementById('password-input').value;
  passwordString = checkIfEmpty(passwordString);
  if (passwordString === '' && !state.syndisInputs.randomPwd) {
    state.syndisInputs.pwdError = true;
  }

  var phoneString = document.getElementById('phone-input').value;
  phoneString = checkIfEmpty(phoneString);

  if (phoneString === '' && state.syndisInputs.randomPwd) {
    state.syndisInputs.phoneError = true;
  }
  state.syndisInputs.phoneInput = phoneString;

  var phoneList = makeList(phoneString);
  phoneList = normalizeList(phoneList);

  if (!validatePhoneList(phoneList)) {
    state.syndisInputs.phoneError = true;
  } else {
    state.syndisData.phoneList = phoneList;
  }
}

// validate phone input string
function validatePhoneList(phoneList) {
  for (let i = 0; i < phoneList.length; i++) {
    if (!isPhoneValid(phoneList[i])) {
      return false;
    }
  }
  return true;
}

// validate a phone number
function isPhoneValid(phoneNumber) {
  // check if normalized string is correct length
  if (phoneNumber.length !== 7) {
    return false;
  }
  return /[0-9][0-9][0-9][0-9][0-9][0-9][0-9]/.test(phoneNumber);
}

// validation for SSN list if SSN protected
function validationForSSN(state) {
  var ssnString = document.getElementById('ssn-input').value;
  ssnString = checkIfEmpty(ssnString);
  state.syndisInputs.ssnInput = ssnString;

  if (ssnString === '') {
    state.syndisInputs.ssnError = true;
    return;
  }

  var ssnList = makeList(ssnString);
  ssnList = normalizeSSNList(ssnList);

  if (!validateSSNList(ssnList)) {
    state.syndisInputs.ssnError = true;
  } else {
    state.syndisData.ssnList = ssnList;
  }
}

function normalizeSSNList(ssnList) {
  ssnList = removeEmptyStrings(ssnList);

  for (let i = 0; i < ssnList.length; i++) {
    let ssn = ssnList[i];
    if (ssn.length === 11 && ssn[6] === '-') {
      ssn = ssn.slice(0, 6) + ssn.slice(7);
    }
    ssnList[i] = ssn;
  }
  return removeDuplicates(ssnList);
}

// validate SSN input string
function validateSSNList(ssnList) {
  for (let i = 0; i < ssnList.length; i++) {
    if (!isSSNValid(ssnList[i])) {
      return false;
    }
  }
  return true;
}

// validate a ssn
function isSSNValid(ssn) {
  if (ssn.length !== 10) {
    return false;
  }

  ssn = ssn.split('');
  const multis = [3, 2, 7, 6, 5, 4, 3, 2];
  let sSum = 0;

  for (let i = 0; i < multis.length; i++) {
    sSum += multis[i] * parseInt(ssn[i]);
  }

  let modRes = sSum % 11;
  if (modRes > 0) {
    modRes = 11 - modRes;
  }

  if (modRes !== parseInt(ssn[8])) {
    return false;
  }

  const century = parseInt(ssn[9]);
  return !(isNaN(century) || (century !== 0 && century !== 9 && century !== 8));
}

module.exports = {
  validateSD,
  checkIfEmpty,
  makeList,
  removeEmptyStrings,
  removeDuplicates,
  normalizeList,
  validateEmailList,
  isEmailValid,
  validationForPassword,
  validatePhoneList,
  isPhoneValid,
  validationForSSN,
  normalizeSSNList,
  validateSSNList,
  isSSNValid
};
